<template>
  <modal
    @confirm="$emit('confirm')"
    @closed="$emit('closed')"
    :close-text="'Cancel'"
    :close-class="'pull-left btn-default mat'"
    :confirm-text="'Confirm'"
    :confirm-class="'btn-danger mat pull-right'"
  >
    <template slot="title">
      <strong>
        Confirm Delete
      </strong>
    </template>
    <div slot="body">
      <div :class="alignClass">
        <slot></slot>
      </div>
      <br />
      <div class="text-center">
        <strong>Are you sure you would like to delete?</strong>
      </div>
    </div>
  </modal>
</template>
<script>
  import Modal from '@shared/Modal.vue';
  export default {
    name: 'DeleteModal',

    components: {
      Modal,
    },

    props: {
      alignClass: {
        type: String,
        required: false,
        default: 'text-center',
      },
    },
  };
</script>
